import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_7c8c06fa from 'nuxt_plugin_plugin_7c8c06fa' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_05fc71aa from 'nuxt_plugin_plugin_05fc71aa' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cmsconfig_4de76899 from 'nuxt_plugin_cmsconfig_4de76899' // Source: ./cms-config.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0a90e1c1 from 'nuxt_plugin_cookieuniversalnuxt_0a90e1c1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_portalvue_1a80004c from 'nuxt_plugin_portalvue_1a80004c' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_metaplugin_5c942df0 from 'nuxt_plugin_metaplugin_5c942df0' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_5344e308 from 'nuxt_plugin_iconplugin_5344e308' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_polyfills_a2ea40e0 from 'nuxt_plugin_polyfills_a2ea40e0' // Source: ../src/plugins/polyfills (mode: 'client')
import nuxt_plugin_vuelazyload_e6901296 from 'nuxt_plugin_vuelazyload_e6901296' // Source: ../src/plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_vcalendar_106a77a9 from 'nuxt_plugin_vcalendar_106a77a9' // Source: ../src/plugins/v-calendar (mode: 'client')
import nuxt_plugin_vueplyr_15ce6bf0 from 'nuxt_plugin_vueplyr_15ce6bf0' // Source: ../src/plugins/vue-plyr (mode: 'client')
import nuxt_plugin_apollo_2286e3c3 from 'nuxt_plugin_apollo_2286e3c3' // Source: ../src/plugins/apollo (mode: 'all')
import nuxt_plugin_browsealoud_f60d4f16 from 'nuxt_plugin_browsealoud_f60d4f16' // Source: ../src/plugins/browsealoud (mode: 'all')
import nuxt_plugin_tracking_b906beaa from 'nuxt_plugin_tracking_b906beaa' // Source: ../src/plugins/tracking (mode: 'client')
import nuxt_plugin_meta_487770fd from 'nuxt_plugin_meta_487770fd' // Source: ./composition-api/meta.mjs (mode: 'all')
import nuxt_plugin_plugin_73d047b1 from 'nuxt_plugin_plugin_73d047b1' // Source: ../src/modules/cms/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Scenkonst Öst","htmlAttrs":{"lang":"sv-SE"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"theme-color","name":"theme-color","content":"#66DA8B"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.scenkonstost.se"},{"hid":"og:site_name","property":"og:site_name","content":"Scenkonst Öst"},{"hid":"og:title","property":"og:title","content":"Scenkonst Öst"},{"hid":"og:description","property":"og:description","content":""},{"hid":"description","name":"description","content":""},{"hid":"author","name":"author","content":"Scenkonst Öst"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon\u002Ffavicon.ico"},{"rel":"icon","href":"\u002Ffavicon\u002Ffavicon.svg"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-mask-icon.svg","color":"#66DA8B"},{"rel":"apple-touch-icon","href":"\u002Ffavicon\u002Fapple-touch-icon-180x180.png"}],"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7c8c06fa === 'function') {
    await nuxt_plugin_plugin_7c8c06fa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_05fc71aa === 'function') {
    await nuxt_plugin_plugin_05fc71aa(app.context, inject)
  }

  if (typeof nuxt_plugin_cmsconfig_4de76899 === 'function') {
    await nuxt_plugin_cmsconfig_4de76899(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0a90e1c1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0a90e1c1(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_1a80004c === 'function') {
    await nuxt_plugin_portalvue_1a80004c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5c942df0 === 'function') {
    await nuxt_plugin_metaplugin_5c942df0(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_5344e308 === 'function') {
    await nuxt_plugin_iconplugin_5344e308(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_a2ea40e0 === 'function') {
    await nuxt_plugin_polyfills_a2ea40e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_e6901296 === 'function') {
    await nuxt_plugin_vuelazyload_e6901296(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_106a77a9 === 'function') {
    await nuxt_plugin_vcalendar_106a77a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplyr_15ce6bf0 === 'function') {
    await nuxt_plugin_vueplyr_15ce6bf0(app.context, inject)
  }

  if (typeof nuxt_plugin_apollo_2286e3c3 === 'function') {
    await nuxt_plugin_apollo_2286e3c3(app.context, inject)
  }

  if (typeof nuxt_plugin_browsealoud_f60d4f16 === 'function') {
    await nuxt_plugin_browsealoud_f60d4f16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_b906beaa === 'function') {
    await nuxt_plugin_tracking_b906beaa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_487770fd === 'function') {
    await nuxt_plugin_meta_487770fd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_73d047b1 === 'function') {
    await nuxt_plugin_plugin_73d047b1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
